<div class="p-5">
  <p class="mb-3">Choose date for re-check up.</p>
  <mat-form-field appearance="outline" class="mb-2">
    <mat-label>Choose Date</mat-label>
    <input matInput [matDatepicker]="picker1" [formControl]="date" />
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
  </mat-form-field>
  <div class="d-flex w-100 justify-content-between my-2">
    <div></div>
    <div>
      <button mat-raised-button color="primary" (click)="handleSubmit()">
        Submit
      </button>
    </div>
  </div>
</div>
